import {Stack} from 'src/design/atoms/Stack';
import {Text} from 'src/design/atoms/Text';
import React from 'react';
import {FormContentHeader} from 'src/app/forms/FormHeader';

/**
 * Builds the InSpec preview's device-card header: equipment-type name,
 * `[Device ID]` placeholder, and a caption clarifying scope — this preview
 * shows field layout/behavior, not a pinned historical inspection snapshot
 * (see `FieldEditor`'s "does not change past inspections" note).
 */
export const createDevicePreviewHeader = (
  equipmentTypeName?: string
): React.ComponentType =>
  function DevicePreviewHeader() {
    return (
      <Stack gap={2} mb="sm">
        <FormContentHeader
          text={equipmentTypeName ?? 'Equipment Type'}
          internalIdentifier="[Device ID]"
        />
        <Text size="xs" c="dimmed">
          Renders exactly as an inspector sees the device in the field.
        </Text>
      </Stack>
    );
  };
